import { Component, OnInit, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { User } from '@shared/models/User';
import { AuthenticationService } from '@app/authentication/authentication.service';
import { StorageService } from '@shared/services/storage.service';
import { Router } from '@angular/router';
import { MessagingService } from '@shared/services/messaging.service';
import { environment } from '@env';
import { DialogService, DialogWidth } from '@shared/services/dialog.service';
import { SigninAsDialogComponent } from '@shared/components/dialogs/signin-as-dialog/signin-as-dialog.component';
import { TimeUtils } from '@shared/utils/time.utils';
import { NpsDialogComponent } from '@shared/dialogs/nps-dialog/nps-dialog.component';
import { ZproService } from '@shared/services/zpro.service';
import { Company } from '@shared/models/Company';
import { CompanyService } from '@shared/http/company.service';
import { CreateTicketDialogComponent } from '@shared/components/dialogs/create-ticket-dialog/create-ticket-dialog.component';
import { interval } from 'rxjs';

@Component({
  selector: 'app-navbar-layout',
  templateUrl: './navbar-layout.component.html',
  styleUrls: ['./navbar-layout.component.scss']
})
export class NavbarLayoutComponent implements OnInit {
  public DEFAULT_LOGO = 'https://ottimizza.com.br/wp-content/themes/ottimizza/images/logo.png';
  APP_URL = `${environment.portalBaseUrl}`;

  currentUser: User;

  logo: string = this.DEFAULT_LOGO;
  public sugestaoMelhorias = environment.urlSugestaoMelhorias;
  public tutorialSugestaoMelhorias = environment.urlDocumentationSugestoes;
  public darkMode = false;

  public readonly STORAGE_KEY = 'dark-mode';
  public isAdmin = false;

  constructor(
    @Inject(DOCUMENT) public document: Document,
    public dialog: DialogService,
    public router: Router,
    public storageService: StorageService,
    public authorizationService: AuthenticationService,
    public messagingService: MessagingService,
    private zpro: ZproService,
    private companyService: CompanyService
  ) { }

  public toggleSidebar() {
    const body = this.document.getElementsByTagName('body')[0];
    const sidebar: HTMLElement = this.document.getElementsByClassName('left-sidebar')[0] as HTMLElement;

    body.classList.toggle('show-sidebar');
    sidebar.focus();
  }

  public openTickets() {
  }

  public openNewTicket() {
    this.dialog.openComplexDialog(CreateTicketDialogComponent, DialogWidth.LARGE, null, {
      disableClose: true,
      maxHeight: '90vh'
    }).subscribe(result => {
        if (result === true) {
            window.location.reload();
        }
    });
  }

  toggleSidebarStyle() {
    const body = this.document.getElementsByTagName('body')[0];
    if (body.classList.contains('compact-sidebar')) {
      body.classList.remove('compact-sidebar');
      body.classList.add('default-sidebar');
    } else {
      body.classList.add('compact-sidebar');
      body.classList.remove('default-sidebar');
    }
  }

  public shouldShowAccountingDetailsPage() {
    return [User.Type.ADMINISTRATOR, User.Type.ACCOUNTANT].includes(this.currentUser.type);
  }

  public logout() {
    this.router.navigate(['auth', 'logout']);
  }

  allowNotifications() {
    this.messagingService.requestPermission().subscribe();
  }

  public async enableDarkMode() {
    this.darkMode = !this.darkMode;
    await TimeUtils.sleep(500);

    if (this.darkMode) {
      localStorage.setItem(this.STORAGE_KEY, 'true');
    } else {
      localStorage.removeItem(this.STORAGE_KEY);
    }
    window.location.reload();
  }

  public openNps() {
    this.dialog.open(NpsDialogComponent);
  }

  public openZpro() {
    this.zpro.toggleChat();
  }

  public back() {
    if (history.length > 2) {
      history.back();
    }
  }

  ngOnInit() {
    this.darkMode = !!localStorage.getItem(this.STORAGE_KEY);
    this.currentUser = User.fromLocalStorage();
    this.isAdmin = this.currentUser.isAdministrator();
    this.setLogo();
    interval(60 * 1000).subscribe(() => this.currentUser = User.fromLocalStorage());
  }

  public goHome() {
    this.router.navigate(['/app/start']);
  }

  public setLogo() {
    if (this.currentUser?.organization && environment.production) {
      const avatar = this.currentUser.organization.avatar;
      this.logo = (avatar) ? avatar : this.DEFAULT_LOGO;
    }
  }

  public newTicket() {
    this.dialog.open(CreateTicketDialogComponent)
  }

  openSiginAsModal() {
    this.dialog.open(SigninAsDialogComponent).subscribe(result => {
      if (result) {
        window.location.href = window.location.href;
      }
    });
  }
}
